import React, { useState, useEffect } from 'react';
import { Tab, Tabs, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaUserSecret, FaUserTie } from 'react-icons/fa';

const LoginForm = () => {
  const [activeTab, setActiveTab] = useState('owner');
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth();

  useEffect(() => {
    if (user) {
      if (user.role === 'owner') {
        navigate('/owner-dashboard');
      } else if (user.role === 'staff') {
        navigate('/staff-dashboard');
      }
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const { username, password } = formData;
      await login(username, password, activeTab);
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  const renderTabTitle = (label, IconComponent, key) => {
    const isActive = activeTab === key;
    const textClass = isActive ? 'text-success' : 'text-dark';
    return (
      <span className={`d-flex align-items-center gap-2 ${textClass}`}>
        <span
          className={`rounded-circle ${isActive ? 'bg-success' : 'bg-dark-subtle'}`}
          style={{ width: '0.5rem', height: '0.5rem' }}
        />
        <IconComponent className={`fs-5 ${textClass}`} />
        <span className="fw-semibold">{label}</span>
      </span>
    );
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow-lg border-0 rounded-4">
            <div className="card-header">
              <h3 className="text-center mb-0">Login</h3>
            </div>
            <div className="card-body">
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
              >
                <Tab
                  eventKey="owner"
                  tabClassName={activeTab === 'owner' ? 'text-success fw-semibold' : 'text-dark'}
                  title={renderTabTitle('Ega', FaUserSecret, 'owner')}
                >
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="owner-username">
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        autoComplete="username"
                      />
                    </Form.Group>
                    <Form.Group controlId="owner-password">
                      <Form.Label>Parol</Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        autoComplete="current-password"
                      />
                    </Form.Group>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <div className="d-flex justify-content-center mt-4">
                      <Button
                        variant="success"
                        type="submit"
                        disabled={isLoading}
                        className="px-4 py-2 w-100 fw-semibold shadow-sm"
                      >
                        {isLoading ? 'Logging in...' : 'Login'}
                      </Button>
                    </div>
                  </Form>
                </Tab>
                <Tab
                  eventKey="staff"
                  tabClassName={activeTab === 'staff' ? 'text-success fw-semibold' : 'text-dark'}
                  title={renderTabTitle('Hodim', FaUserTie, 'staff')}
                >
                  <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="staff-username">
                      <Form.Label>Username</Form.Label>
                      <Form.Control
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        autoComplete="username"
                      />
                    </Form.Group>
                    <Form.Group controlId="staff-password">
                      <Form.Label>Parol</Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        autoComplete="current-password"
                      />
                    </Form.Group>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <div className="d-flex justify-content-center mt-4">
                      <Button
                        variant="success"
                        type="submit"
                        disabled={isLoading}
                        className="px-4 py-2 w-100 fw-semibold shadow-sm"
                      >
                        {isLoading ? 'Logging in...' : 'Login'}
                      </Button>
                    </div>
                  </Form>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;